module.exports = __webpack_public_path__ + "img/step_8.3e6b65de.svg";